import { Helpers } from '@/helpers/Helpers'
const emailormobile = function (node) {
    if(Helpers.validateEmail(node.value) != null || Helpers.validateMobile(node.value) != null){
        return true
    }else{
        return false
    }
}
export default emailormobile